import { apiClient, handleApiError } from './client';
import type {
  CreateSuggestionRequest,
  Suggestion,
  SuggestionListResult,
} from '@om/shared-types';

interface SuggestionApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

interface SuggestionListApiResponse {
  success: boolean;
  data: Suggestion[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

export class SuggestionService {
  async submitSuggestion(payload: CreateSuggestionRequest): Promise<Suggestion> {
    try {
      const body: CreateSuggestionRequest = {
        ...payload,
        page_url: payload.page_url || (typeof window !== 'undefined' ? window.location.href : undefined),
        user_agent: payload.user_agent || (typeof navigator !== 'undefined' ? navigator.userAgent : undefined),
      };

      const response = await apiClient.post<SuggestionApiResponse<Suggestion>>('/suggestions', body);
      return response.data.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async getMySuggestions(limit: number = 20, offset: number = 0): Promise<SuggestionListResult> {
    try {
      const response = await apiClient.get<SuggestionListApiResponse>('/suggestions/my', {
        params: {
          limit,
          offset,
        },
      });

      return {
        data: response.data.data,
        total: response.data.pagination.total,
        limit: response.data.pagination.limit,
        offset: response.data.pagination.offset,
        hasMore: response.data.pagination.hasMore,
      };
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }
}

export const suggestionService = new SuggestionService();
